var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('cookie-law',{attrs:{"theme":"blood-orange"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }